import { IAxiosResponseData } from '@/store';
import { axios } from '@/nmb/request';

const api = `api/Mysoft.Calendar.Common.AppServices.FollowAppService/`;

export const GetFollowedUserInfo = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetFollowedUserInfo`, params);

export const RefuseSomeoneFollowedMe = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}RefuseSomeoneFollowedMe`, params);

export const AgreeSomeoneFollowedMe = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}AgreeSomeoneFollowedMe`, params);
// 取消我关注的人
export const cancelSomeoneIFollowed = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}CancelSomeoneIFollowed`, params);
// 我关注的
export const getUserListIFollowed = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserListIFollowed`, params);
// 推荐关注人列表
export const getUserListRecommendToFollow = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserListRecommendToFollow`, params);
// 关注我的
export const getUserListIFollowedMe = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserListFollowedMe`, params);
// 关注某人
export const followedSomeone = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}FollowedSomeone`, params);
// 取消关注我的
export const cancelSomeoneFollowedMe = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}CancelSomeoneFollowedMe`, params);
// 获取集团关注人列表
export const getUserListInGroupToFollow = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserListInGroupToFollow`, params);
// 查询自由关注状态
export const getUserFollowSetting = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserFollowSetting`, params);
// 设置用户关注
export const setUserFollowSetting = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}SetUserFollowSetting`, params);
